import { jsx as _jsx } from "react/jsx-runtime";
const fallbackClassByKind = {
    'invalid-config': 'rounded-xl border border-rose-200 bg-rose-50 px-3 py-2 text-xs text-rose-800',
    'missing-renderer': 'rounded-xl border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-800',
    'plugin-runtime-disabled': 'rounded-xl border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-800',
    'plugin-runtime-unavailable': 'rounded-xl border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-800',
    'renderer-error': 'rounded-xl border border-rose-200 bg-rose-50 px-3 py-2 text-xs text-rose-800',
};
export const renderDefaultFallback = ({ block, kind, message, }) => (_jsx("div", { className: fallbackClassByKind[kind], children: message }, block.id));
